export const CMS_COUPON_PREFIX = 'cms-coupons-';

const CMS_COUPON_ID_REGEX = new RegExp(
    `${CMS_COUPON_PREFIX.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(.*?)-(\\d+)`
);

/**
 * Returns whether the coupon id represents a CMS coupon subscription.
 *
 * @param {string} couponId - Coupon or event group subscription id.
 * @returns {boolean} True when the id is a CMS coupon subscription id.
 */
export const isCmsCoupon = couponId => couponId?.lastIndexOf(CMS_COUPON_PREFIX, 0) === 0;

/**
 * Extracts sport id from a CMS coupon event group id.
 *
 * @param {string} couponId - CMS coupon event group subscription id.
 * @returns {string | undefined} The sport id.
 */
export const extractCouponSportId = couponId => couponId?.match(CMS_COUPON_ID_REGEX)?.[1];

/**
 * Extracts CMS coupon id from a CMS coupon event group id.
 *
 * @param {string} couponId - CMS coupon event group subscription id.
 * @returns {string | undefined} The CMS coupon id.
 */
export const extractCouponId = couponId => couponId?.match(CMS_COUPON_ID_REGEX)?.[2];
